// extracted by mini-css-extract-plugin
export default {"buttonDownload":"zip-button-file_buttonDownload__+y2mI","downloadArrow":"zip-button-file_downloadArrow__f+oqm"};